import { ChangeDetectionStrategy, Component, OnDestroy, ViewChild } from '@angular/core';
import { combineLatestWith, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { LocationListLocalStoreService } from '../location-list-local-store.service';
import { Location } from '../../../../models/locations-models/location';
import * as locationListSelectors from '../state/location-list-selectors';
import { LocationListService } from '../location-list.service';
import { LocationDetail } from '../../enums/location-detail';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { LocationListApiService } from '../location-list-api.service';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { GtagEventDirective } from '../../../../core/gx-gtag/gtag-event.directive';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-row-menu',
    templateUrl: './row-menu.component.html',
    styleUrls: ['./row-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatMenu, MatMenuContent, LetDirective, MatMenuItem, GtagEventDirective, MatIcon, MatMenuTrigger, MatDivider]
})
export class RowMenuComponent implements OnDestroy {

  // needed by rowMenuTrigger
  @ViewChild('rowActionMenu') rowActionMenu: MatMenu;

  componentDestroyed = new Subject<void>();
  locationDetail = LocationDetail;

  constructor(private store: Store,
              private gridLocalStore: LocationListLocalStoreService,
              public locationListService: LocationListService,
              public gridApiService: LocationListApiService) {}

  ngOnDestroy() {
    this.componentDestroyed.next();
  }

  getMenuViewModel$(location: Location): Observable<{
    canTransfer: boolean,
    canUpdateInGbp: boolean,
    canRefreshGbp: boolean,
    canArchive: boolean,
    canBlacklist: boolean,
    canSyncReviews: boolean,
    canCreateGbpConnection: boolean,
    canRemoveGbpConnection: boolean,
    canIgnoreLastUpdateError: boolean,
    showTranslation: boolean,
  }> {
    return this.store.select(locationListSelectors.selectRowMenuViewModel(location))
        .pipe(
            combineLatestWith(this.gridLocalStore.showTranslations$,
                this.gridLocalStore.loadingTranslations$),
            map(([menuViewModel, showTranslations]) => {
              return { ...menuViewModel, showTranslation: showTranslations[location?.id] };
            }),
            takeUntil(this.componentDestroyed));
  }

  toggleShowTranslation(locationId: number) {
    this.gridLocalStore.toggleShowTranslation$(locationId);
  }




}
